var map = {
	"./CyberSecurityImg.png": 83,
	"./ProgrammingImg.png": 84,
	"./address_image.svg": 85,
	"./adorebits_logo.png": 86,
	"./aig_logo.png": 87,
	"./animated_logo.svg": 88,
	"./blogs_image.svg": 89,
	"./canva_logo.png": 90,
	"./cloud_infrastructure.svg": 91,
	"./codeInLogo.png": 92,
	"./contactMail.png": 93,
	"./coursera_logo.png": 94,
	"./data_science.svg": 95,
	"./dau_logo.png": 96,
	"./deeplearning_ai_logo.png": 97,
	"./delhivery_logo.png": 98,
	"./deloitte_logo.png": 99,
	"./developerActivity.svg": 100,
	"./dsc_logo.png": 101,
	"./education.svg": 102,
	"./experience.svg": 103,
	"./feelingProud.svg": 104,
	"./forensic_knight_logo.png": 105,
	"./freecopy_logo.png": 106,
	"./fullstack.svg": 107,
	"./gcp_logo.png": 108,
	"./github_logo.png": 109,
	"./googleAssistant.jpg": 110,
	"./googleAssistant.svg": 111,
	"./google_logo.png": 112,
	"./growpartner_logo.png": 113,
	"./gyandeep_logo.png": 114,
	"./hackingflix_logo.png": 115,
	"./ibm_logo.png": 116,
	"./intel_logo.jpg": 117,
	"./isro_logo.png": 118,
	"./iu_logo.png": 119,
	"./jsFramework.svg": 120,
	"./legato_logo.png": 121,
	"./manOnTable.svg": 122,
	"./mastercard_logo.png": 123,
	"./masterportfolio-banner-light.png": 124,
	"./microsoft_logo.png": 125,
	"./mozilla_logo.png": 126,
	"./muffito_logo.png": 127,
	"./nextuLogo.jpg": 128,
	"./nptel_logo.png": 129,
	"./oracle_logo.png": 130,
	"./pdeu_logo.png": 131,
	"./portfolio.gif": 132,
	"./powerbi_logo.png": 133,
	"./preet.png": 134,
	"./programmer.svg": 135,
	"./projects_image.svg": 136,
	"./pwa.png": 137,
	"./saayaHealthLogo.png": 138,
	"./savgun_logo.png": 139,
	"./shakti_logo.png": 140,
	"./som_logo.png": 141,
	"./stanford_logo.png": 142,
	"./talksCardBack.svg": 143,
	"./talksCardBackAlt.svg": 144,
	"./tdo_logo.png": 145,
	"./thakkarbapa_logo.png": 146,
	"./ui_ux_design.svg": 147,
	"./walmart_logo.png": 148,
	"./zidio_logo.png": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;